// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"2a32634ce2955b43e057","339":"1574065e4dead1ee2231"}[chunkId] + ".js";
};